module.exports = __webpack_public_path__ + "static/media/marker-pos-icon.f718f461.svg";